import { Component, inject, OnInit, output } from '@angular/core';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { PROGRAM_TARGET_TABLE_COLUMNS } from './program-target-table.columns';
import { ComponentsModule } from '@shared/components/components.module';
import { UtilitiesService } from '@services/utilities.service';
import { ProgramTargetService } from '../../services/program-target.service';
import { IProgramTarget } from '../../interfaces/tab-program-target.interface';

@Component({
  selector: 'app-program-target-table',
  standalone: true,
  imports: [MatTableModule, MatSortModule, ComponentsModule],
  templateUrl: './program-target-table.component.html',
  styleUrl: './program-target-table.component.scss',
})
export class ProgramTargetTableComponent implements OnInit {
  readonly service = inject(ProgramTargetService);
  readonly utilityService = inject(UtilitiesService);

  tableColumns = PROGRAM_TARGET_TABLE_COLUMNS;
  displayedColumns = this.tableColumns.map((column) => column.key);

  readonly dataSource = this.service.dataSource;

  readonly actionDetail = output<IProgramTarget>();

  ngOnInit(): void {
    // bypass privilege
    this.tableColumns = this.utilityService.privilegeTableColumns(true, this.tableColumns);
    this.displayedColumns = this.tableColumns.map((column) => column.key);
  }

  onDetail(row: IProgramTarget): void {
    this.actionDetail.emit(row);
  }
}
